import React from 'react';
import classNames from 'classnames';
import { BringgFontIcons, BringgIcon } from '@bringg/bringg-icons';

export enum MODES {
	EDIT = 'edit',
	VIEW = 'view'
}

export interface EditButtonProps {
	onSave: (event) => any;
	onCancel: (event) => void;
	onEdit: (event) => void;
	mode: MODES;
	title?: string;
}

const EditButton: React.FC<EditButtonProps> = ({ onSave, onEdit, onCancel, mode, title }) => {
	const titleElement = title ? (
		<div className={classNames('edit-title', mode)} onClick={onEdit}>
			{title}
		</div>
	) : null;

	return (
		<div className="edit-button-container">
			{titleElement}
			<div className={classNames('edit-button', mode)} onClick={onEdit}>
				<BringgIcon iconName={BringgFontIcons.Pencil} className="edit-icon" />
			</div>
			<div className={classNames('save-button', mode)} onClick={onSave}>
				<BringgIcon iconName={BringgFontIcons.Selected} className="selected-icon" />
			</div>
			<div className={classNames('cancel-button', mode)} onClick={onCancel}>
				<BringgIcon iconName={BringgFontIcons.Close} className="close-icon" />
			</div>
		</div>
	);
};

export default EditButton;
